import script from "./media-hero.vue?vue&type=script&lang=js"
export * from "./media-hero.vue?vue&type=script&lang=js"

import "./media-hero.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__